import { DetailView } from '@components/enitity'
import FlatsForm from '@features/flats/components/FlatsForm'
import { useCreateFlat } from '@services/flats/mutations/useCreateFlat'
import { FlatWrite } from '@services/flats/types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export function FlatsCreate() {
  const { t } = useTranslation('flat')
  const navigate = useNavigate()
  const { mutate: createFlat } = useCreateFlat()

  const submitFlat = (values: FlatWrite) => {
    createFlat({
      body: values,
      params: {
        onSuccess: (data) => {
          navigate(`/admin/flats/${data.id}`)
        }
      }
    })
  }

  return (
    <div className="space-y-6">
      <DetailView.Breadcrumb
        parentLabel={t('title')}
        parentTo="/admin/flats"
        current={t('create_title')}
      />

      <FlatsForm handleSubmit={submitFlat} />
    </div>
  )
}
